import { formatLabel, optionsHorizontalBar } from "./utils"

const cd_direct_recovery_region = {
  figureNumber: "2.2",
  title: "Region",
  subTitle: "FY 2022 (percentage share of total)",
  source: "Sources: IMF, Capacity Development Management and Administration Program; and IMF staff calculations.",
  data: {
    labels: [
      formatLabel("Sub-suharan Africa", 30),
      formatLabel("Asia and Pacific", 30),
      formatLabel("Western Hemisphere", 30),
      formatLabel("Middle East & Central Asia", 30),
      formatLabel("Europe", 30),
      formatLabel("Multi-regional", 30),
    ],
    datasets: [
      {
        label: "",
        data: [38, 19, 17, 13, 9, 4],
        backgroundColor: "#008FC4",
      },
    ],
  },
  options: optionsHorizontalBar,
}

export default cd_direct_recovery_region;